import React, { createContext, useContext, useEffect, useState } from 'react';
import { NetworkProvider } from './NetworkProvider';

// Create the context
const UserContext = createContext(null);

// Custom hook for easy access
export const useUser = () => useContext(UserContext);

// Provider component
export const UserProvider = ({ children }) => {
    const [user, setUserState] = useState(null);
    const [userReady, setUserReady] = useState(false);


    const loadUser = async () => {
        try {
            const response = await NetworkProvider.getUser()
            setUser(response.user)
            return response.user
        } catch (error) {
            console.log(error);
        } finally {
            setUserReady(true)
        }
    }

    // Save user to localStorage whenever it changes
    const setUser = (newUser) => {
        if (newUser) {
            localStorage.setItem('user', JSON.stringify(newUser));
        } else {
            localStorage.removeItem('user');
        }
        setUserState(newUser);
    };

    const wipeUser = () => {
        setUser(null);
        localStorage.removeItem('user');
    };

    return (
        <UserContext.Provider value={{ user, setUser, loadUser, wipeUser, userReady }}>
            {children}
        </UserContext.Provider>
    );
};
